// extracted by mini-css-extract-plugin
export default {"closeIcon":"B1wbxrNDVmn6XQZf2wMg","common_bganimation":"fvLHWmTBziqbKyg3Znps"};